import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';

const ServerTable = ({ servers, onSelectServer }) => {
    return (
        <Paper className="server-explorer-table-container">
            <TableContainer>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell className="server-explorer-header-cell">Server ID</TableCell>
                            <TableCell className="server-explorer-header-cell">Operator ID</TableCell>
                            <TableCell className="server-explorer-header-cell">Server Name</TableCell>
                            <TableCell className="server-explorer-header-cell">Site</TableCell>
                            <TableCell className="server-explorer-header-cell">Lobby Name</TableCell>
                            <TableCell className="server-explorer-header-cell">Environment</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {servers.map((server, index) => (
                            <TableRow
                                key={`${server.serverId}-${index}`}
                                hover
                                onClick={() => onSelectServer(server)}
                                className="server-explorer-table-row"
                            >
                                <TableCell>{server.serverId}</TableCell>
                                <TableCell>{server.operatorID}</TableCell>
                                <TableCell>{server.serverName}</TableCell>
                                <TableCell>{server.regulatedMarketShort}</TableCell>
                                <TableCell>{server.brandName}</TableCell>
                                <TableCell>{server.environment}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default ServerTable;